import { componentsLayzyMap } from '@/config/router.config'
import * as InitCanvas from 'simulate_three'

import * as cc from 'my-design-canvas/desf4fc'
import store from '@/store/index'
import { threeRenderMain } from './threeSceneRender'
cc.Object.prototype.objectCaching = false
const PrintAreas = {
  // id: 245,
  // view_id: 1,
  offset_x: '0.00000',
  offset_y: '0.00000',
  width: '1100.00000',
  height: '1100.00000'
  // actual_width: '482.00000',
  // soft_svg: '',
  // view_name: 'A\u9762'
}

export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader(callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function() {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

export function isIE() {
  const bw = window.navigator.userAgent
  const compare = s => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}
// 生成随机字符串
export function randomString(len) {
  len = len || 32
  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  var maxPos = chars.length
  var pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd + new Date().getTime()
}

export function getFabricScale(reborderInfo, imgInfo, type = 1) {
  const { width: imgWidth, height: imgHeight } = imgInfo
  const { width: redWidth, height: redHeight } = reborderInfo
  const tag = imgHeight / imgWidth >= redHeight / redWidth
  if (type === 1) {
    return tag ? redHeight / imgHeight : redWidth / imgWidth
  } else {
    return tag ? redWidth / imgWidth : redHeight / imgHeight
  }
}
// 动态添加fabric
// export function addImgToFabricFunc(fabricName, imgSrc) {}
// 生成canvas
export function createCanvasObj(height) {
  const canvas = document.createElement('canvas')
  canvas.height = height
  canvas.width = height
  return canvas
}
// 关闭pedding

// 关闭生成动态路由
export function mapData(data) {
  return data.map(item => {
    const pTitle = item.name
    return {
      path: item.http_url,
      name: item.web_name,
      component: componentsLayzyMap[item.component],
      redirect: item.children.length ? item.children[0].http_url : '',
      children: item.children.length ? mapData(item.children) : [],
      meta: {
        title: item.name,
        pTitle,
        show: item.is_menu === 1,
        showButton: item.operates ? item.operates.map(item => item.name) : [],
        from: item.img_url,
        parent_id: item.parent_id,
        is_blank: item.is_blank
      }
    }
  })
}

export function createRouters(data) {
  return mapData(data)
}

export function flatArr(arr) {
  return arr.reduce((prev, cur) => {
    return prev.concat(Array.isArray(cur) ? flatArr(cur) : cur)
  }, [])
}

export function html_decode(str) {
  // eslint-disable-next-line no-unused-vars
  let s = ''
  if (str.length === 0) return ''
  s = str.replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return s
}

export function getFroms(children) {
  const froms = []
  children.map(item => {
    if (froms.indexOf(item.meta.from) === -1) {
      froms.push(item.meta.from)
    }
  })
  return froms
}
export function getTip(deforLevelH, deforLevelW) {
  return deforLevelW >= deforLevelH ? deforLevelW : deforLevelH
}
// 获取真实宽度
export function getActualSizeTip(height, width, scaleX, scaleY, onePxToRealWidth, dpi, pxH, pxW) {
  console.log(height, width, scaleX, scaleY, onePxToRealWidth, dpi, pxH, pxW)
  const cmToInch = 0.3937008
  const actualH = (height * scaleY * onePxToRealWidth * cmToInch) / 10
  const actualW = (width * scaleX * onePxToRealWidth * cmToInch) / 10
  const deforLevelH = dpi - pxH / actualH.toFixed(0) <= 0 ? 0 : dpi - pxH / actualH.toFixed(0)
  const deforLevelW = dpi - pxW / actualW.toFixed(0) <= 0 ? 0 : dpi - pxW / actualW.toFixed(0)

  return getTip(Math.floor(deforLevelH / 10), Math.floor(deforLevelW / 10))
}

export async function createSinglePreviewImg(imgList, srcs, index) {
  // await threeRenderMain(596.4923443488034, 'https://imagetest.s2bdiy.com/modelFile/201203_1603.glb')
  const { zoom } = store.state.design
  const ca = document.createElement('canvas')
  ca.height = 469
  ca.width = 469
  const caObj = new cc.StaticCanvas(ca, {})
  // eslint-disable-next-line no-unused-vars
  // eslint-disable-next-line no-unused-vars
  var base64 = []
  for (let i = 0; i < imgList.length; i++) {
    const canvas = document.createElement('canvas')
    canvas.height = 469
    canvas.width = 469
    const canObj = new cc.StaticCanvas(canvas, {})
    const imgItem = imgList[i]
    if (imgItem.is_model && i === 1) {
      if (imgItem.show_model === 1) {
        const threeModel = await threeRenderMain(imgItem, index)
        base64.push(threeModel)
      }
      continue
    }
    imgItem.image_src &&
      // eslint-disable-next-line promise/param-names
      (await new Promise(res => {
        cc.Image.fromURL(
          imgItem.image_src,
          function(img) {
            canObj.add(img)
            res()
          },
          { crossOrigin: 'anonymous' }
        )
      }))

    if (!imgItem.is_model) {
      for (let j = 0; j < srcs.length; j++) {
        if (imgList[i].view_id === srcs[j].view_id && srcs[j].canObj) {
          var imgData
          if (imgList[i].is_point === 1) {
            let canvas = document.createElement('canvas')
            canvas.height = 469
            canvas.width = 469
            let img = new Image()
            img.src = srcs[j].canObj.toDataURL({ multiplier: zoom })
            // eslint-disable-next-line promise/param-names
            await new Promise(res => {
              img.onload = () => {
                // eslint-disable-next-line no-new
                new InitCanvas(canvas, JSON.stringify(imgList[i].point_origin_config), PrintAreas, img)
                imgData = canvas.toDataURL()
                img = null
                canvas = null
                res()
              }
            })
          } else {
            imgData = srcs[j].canObj.toDataURL({ multiplier: zoom })
          }
          // eslint-disable-next-line promise/param-names
          await new Promise(res => {
            cc.Image.fromURL(
              imgData,
              function(img) {
                img.set({
                  globalCompositeOperation: 'source-atop'
                })
                if (imgList[i].is_point === 2) {
                  const { canvas_config } = imgList[i]
                  // 缩放设置与后台裁切的比值为准
                  img.set({
                    ...canvas_config,
                    scaleX: canvas_config.scaleX / 0.458,
                    scaleY: canvas_config.scaleY / 0.458
                  })
                }
                canObj.add(img)
                res()
              },
              { crossOrigin: 'anonymous' }
            )
          })
          imgData = ''
        }
      }
    }

    imgItem.image_src && base64.push(canObj.toDataURL({ format: 'png' }))
  }
  for (let c = 0; c < base64.length; c++) {
    // eslint-disable-next-line promise/param-names
    await new Promise(res => {
      cc.Image.fromURL(base64[c], function(img) {
        caObj.add(img)
        res()
      })
    })
  }
  // eslint-disable-next-line no-unused-vars
  var src = caObj.toDataURL({ format: 'png' })
  store.commit('SET_SHOW_IMG_LIST', { data: src, index })
  src = ''

  base64 = []
  console.log(new Date().getTime())
}
export async function mergeImg(showBig) {
  const { zoom } = store.state.design
  const { slideIndex, fabricList } = store.state.design
  const { is_3d } = store.state.design.printImgInfo
  const { show_images_design } = store.getters
  // 3d入口
  if (is_3d === 1) {
    const showImg = {}
    const activeShowImg = show_images_design[slideIndex]
    const { is_user_show_image, show_model } = activeShowImg[0]
    const imgItems = activeShowImg[1].items || []
    if (show_model === 1) {
      showImg['designImg'] = await threeRenderMain(activeShowImg[1], slideIndex)
      showImg['over'] = 1
    }
    showImg['is_user_show_image'] = is_user_show_image
    // showImg['layerImg'] = showBig ? activeShowImg[2].big_image_src : activeShowImg[2].image_src
    if (imgItems && imgItems.length) {
      showImg['layerImg'] = showBig ? imgItems[0].big_layer_image_src : imgItems[0].layer_image_src
    } else {
      showImg['layerImg'] = showBig ? activeShowImg[2].big_image_src : activeShowImg[2].image_src
    }
    store.commit(showBig ? 'SET_SHOW_IMG_LIST_BIG' : 'SET_SHOW_IMG_LIST', { data: showImg, index: slideIndex })
    if (showBig) {
      for (let i = 0; i < show_images_design.length; i++) {
        const showImg = {}
        if (i === slideIndex) {
          continue
        }
        const showImgInfo = show_images_design[i]
        const { is_user_show_image, show_model } = showImgInfo[0]
        const imgItems = showImgInfo[1].items || []
        if (show_model === 1) {
          showImg['designImg'] = await threeRenderMain(showImgInfo[1], i)
          showImg['over'] = 1
        }
        showImg['is_user_show_image'] = is_user_show_image
        // showImg['layerImg'] = showBig ? showImgInfo[2].big_image_src : showImgInfo[2].image_src
        if (imgItems && imgItems.length) {
          showImg['layerImg'] = showBig ? imgItems[0].big_layer_image_src : imgItems[0].layer_image_src
        } else {
          showImg['layerImg'] = showBig ? showImgInfo[2].big_image_src : showImgInfo[2].image_src
        }
        store.commit(showBig ? 'SET_SHOW_IMG_LIST_BIG' : 'SET_SHOW_IMG_LIST', { data: showImg, index: i })
      }
    }

    return
  }
  // 非3d入口
  console.log('setRamdom')
  // const userDesign = fabricList.map(item => {
  //   const img = item.canObj.toDataURL({
  //     multiplier: zoom * (showBig ? 1000 / 550 : 1)
  //   })
  //   return {
  //     view_id: item.view_id,
  //     img
  //   }
  // })
  const firstMergeImg = show_images_design[slideIndex]
  const canvasForMerge = createCanvas(showBig)
  const firstResultImg = {}
  const canvasForResult = createCanvas(showBig)
  console.log('firstMergeImg=====', firstMergeImg)
  for (let i = 0; i < firstMergeImg.length; i++) {
    const { view_id, image_src, is_user_show_image, big_image_src } = firstMergeImg[i]
    if (view_id === 0) {
      firstResultImg['layerImg'] = showBig ? big_image_src : image_src
      firstResultImg['is_user_show_image'] = is_user_show_image
      firstResultImg['over'] = i === 0 ? -1 : 1
    } else {
      const activeFabric = fabricList.find(item => item.view_id === view_id)
      const designObject = {
        img: activeFabric.canObj.toDataURL({
          multiplier: zoom * (showBig ? 1000 / 550 : 1)
        })
      }
      const img = await addImgForMerge(
        firstMergeImg[i],
        // userDesign.find(item => item.view_id === view_id),
        designObject,
        canvasForMerge,
        showBig ? 1000 : 469
      )
      canvasForMerge.clear()
      await addImgToFabric(img, canvasForResult)
    }
  }
  firstResultImg['designImg'] = canvasForResult.toDataURL()
  store.commit(showBig ? 'SET_SHOW_IMG_LIST_BIG' : 'SET_SHOW_IMG_LIST', { data: firstResultImg, index: slideIndex })
  canvasForResult.clear()
  // 第二步合成剩下的图
  if (showBig) {
    for (let j = 0; j < show_images_design.length; j++) {
      if (j === slideIndex) {
        continue
      }
      const secondResultImg = {}
      const singleImg = show_images_design[j]
      for (let s = 0; s < singleImg.length; s++) {
        const { view_id, image_src, is_user_show_image, big_image_src } = singleImg[s]
        if (view_id === 0) {
          secondResultImg['layerImg'] = showBig ? big_image_src : image_src
          secondResultImg['is_user_show_image'] = is_user_show_image
          secondResultImg['over'] = s === 0 ? -1 : 1
        } else {
          const activeFabric = fabricList.find(item => item.view_id === view_id)

          const designObject = {
            img: activeFabric.canObj.toDataURL({
              multiplier: zoom * (showBig ? 1000 / 550 : 1)
            })
          }
          const img = await addImgForMerge(
            singleImg[s],
            // userDesign.find(item => item.view_id === view_id),
            designObject,
            canvasForMerge,
            showBig ? 1000 : 469
          )
          canvasForMerge.clear()
          await addImgToFabric(img, canvasForResult)
        }
      }
      secondResultImg['designImg'] = canvasForResult.toDataURL()
      store.commit(showBig ? 'SET_SHOW_IMG_LIST_BIG' : 'SET_SHOW_IMG_LIST', { data: secondResultImg, index: j })
      canvasForResult.clear()
    }
  }
}
export function createCanvas(showBig) {
  const canvas = document.createElement('canvas')
  canvas.height = showBig ? 1000 : 469
  canvas.width = showBig ? 1000 : 469
  return new cc.StaticCanvas(canvas, {})
}
export function addImgForMerge(imgInfo, userDesignImg, canvasForMerge, width) {
  // eslint-disable-next-line promise/param-names
  return new Promise(res => {
    const imageSrc = width === 1000 ? imgInfo.big_image_src : imgInfo.image_src
    cc.Image.fromURL(
      imageSrc,
      async img => {
        canvasForMerge.add(img)
        if (userDesignImg === null) {
          canvasForMerge.renderAll()
        } else {
          const { is_point, canvas_config, point_origin_config } = imgInfo
          if (is_point === 1) {
            const threeImg = await createThreeImg(
              userDesignImg.img,
              width,
              point_origin_config.map(item => {
                return {
                  x: item.x / (469 / width),
                  y: item.y / (469 / width)
                }
              })
            )
            await addImgToFabric(threeImg, canvasForMerge, { globalCompositeOperation: 'source-atop' })
          } else {
            await addImgToFabric(userDesignImg.img, canvasForMerge, {
              globalCompositeOperation: 'source-atop',
              ...canvas_config,
              top: (canvas_config.top * width) / 469,
              left: (canvas_config.left * width) / 469,
              scaleX: canvas_config.scaleX * (width === 1000 ? 1 : width / 550) * (1200 / 469),
              scaleY: canvas_config.scaleY * (width === 1000 ? 1 : width / 550) * (1200 / 469)
            })
          }
        }
        res(canvasForMerge.toDataURL())
      },
      { crossOrigin: 'anonymous' }
    )
  })
}

function createThreeImg(userDesignImg, width, point_origin_config) {
  const PrintAreas = {
    offset_x: '0.00000',
    offset_y: '0.00000',
    width: `${width * 2}`,
    height: `${width * 2}`
  }
  // eslint-disable-next-line promise/param-names
  return new Promise(res => {
    const img = new Image()
    img.src = userDesignImg
    img.onload = () => {
      const c = new InitCanvas({ height: width, width: width }, JSON.stringify(point_origin_config), PrintAreas, img)
      res(c.canvas.toDataURL())
    }
  })
}
export function addImgToFabric(imgsrc, canvasForResult, config) {
  // eslint-disable-next-line promise/param-names
  return new Promise(res => {
    cc.Image.fromURL(
      imgsrc,
      img => {
        config && img.set(config)
        canvasForResult.add(img)
        canvasForResult.renderAll()
        res()
      },
      { crossOrigin: 'anonymous' }
    )
  })
}
// 判断是否展示缩约图
export function isImgFormat(str) {
  const arr = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff']
  if (str) {
    str = str + ''
    if (str.indexOf('.') >= 0) {
      return arr.indexOf(str.split('.')[str.split('.').length - 1]) >= 0 ? 1 : 2
    } else {
      return 2
    }
  } else {
    return 1
  }
}
export function transformJSON(canvas) {
  const layers = canvas.toJSON([
    'material_code',
    'oss_file_id',
    'material_id',
    'vision_oss_file_id',
    'oss_file_id',
    'material_id',
    'is_batch',
    'batchSrc',
    'style',
    'time',
    'removed',
    'groupType',
    'paddingX',
    'paddingY',
    'pxH',
    'pxW',
    'vision_type',
    'uuid'
  ])
  canvas.layers = layers.objects
  canvas.historyRedo.push(layers)
  if (canvas.historyRedo.length > 10) {
    canvas.historyRedo.splice(0, 1)
  }
}
export function saveHistory() {
  const canvas = store.getters.activeFabric
  const { syncOtherSide, fabricList } = store.state.design
  if (syncOtherSide) {
    fabricList.map(item => {
      transformJSON(item.canObj)
    })
  } else {
    transformJSON(canvas)
  }
}
// 分类求和
export function reduceFn(arr) {
  if (arr.length) {
    return arr.reduce((sum, item) => {
      const num = item.num || 0
      return parseFloat((+sum + +num).toPrecision(12))
    }, 0)
  } else {
    return 0
  }
}

export function toTreeData(data, pid) {
  function tree(id) {
    const arr = []
    data
      .filter(item => {
        return item.parent_category_id === id
      })
      .forEach(item => {
        arr.push({
          value: item.category_id + '',
          label: item.display_category_name,
          children: tree(item.category_id)
        })
      })
    return arr
  }
  return tree(pid)
}
export function getWhCm() {
  const { fabricList, activeDesign, printImgInfo, initialSize } = store.state.design
  const activeFabricData = fabricList.find(item => {
    return item.view_id === activeDesign
  })
  const activeFabric = activeFabricData ? activeFabricData.canObj : undefined
  if (activeFabric) {
    const { actual_sizes, print_areas } = printImgInfo
    const activeObject = activeFabric.getActiveObject()
    const activeSize = actual_sizes.find(item => {
      return item.size_id === initialSize
    })
    const activePrint = print_areas.find(item => {
      return item.view_id === activeDesign
    })
    if (activeObject && activeObject.type === 'image' && actual_sizes && activeSize) {
      const dW = +(activeSize.actual_width || 0) / +(activePrint.width || 0)
      const w = (dW * (activeObject.width || 0) * (activeObject.scaleX || 0)) / 10
      const h = (dW * (activeObject.height || 0) * (activeObject.scaleY || 0)) / 10
      return `Width * Height: ${w.toFixed(1)} * ${h.toFixed(1)}(cm)`
    } else {
      return ''
    }
  } else {
    return ''
  }
}
